"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

/**
 *
 * Grabbed from https://github.com/feross/is-buffer/blob/master/index.js => es6 + prettier
 *
 * @param {buffer} buffer
 * @returns {boolean}
 */
var _default = function _default(buffer) {
  return buffer != null && buffer.constructor != null && typeof buffer.constructor.isBuffer === 'function' && buffer.constructor.isBuffer(buffer);
};

exports.default = _default;
//# sourceMappingURL=isBuffer.js.map
